import React, { FC, useMemo, useState } from 'react';
import { FriendRequest } from '@/services/friends/friendsServicesTypes';
import Button, { ButtonSizes, ButtonVariants } from '@/components/new-design/Button';
import { SortingState, CoreRow } from '@tanstack/react-table';
import GenericTable from '@/components/GenericTable/GenericTable';
import FriendsTableAvatar from '@/components/Friends/FriendsTableAvatar';

interface FriendRequestTableProps {
  data: FriendRequest[];
  handleAccept: (userId: string) => void;
  handleDecline: (userId: string) => void;
}
const FriendRequestTable: FC<FriendRequestTableProps> = ({ data, handleAccept, handleDecline }) => {
  const [sorting, setSorting] = useState<SortingState>([
    {
      id: 'firstName',
      desc: false,
    },
  ]);

  const columns = useMemo(
    () => [
      {
        accesoryKey: 'alias',
        header: 'Alias',
        enableSorting: true,
        cell: ({ row }: { row: CoreRow<FriendRequest> }) => (
          <FriendsTableAvatar id={row?.original?.sender?.id} alias={row?.original?.sender?.alias} />
        ),
      },
      {
        accesoryKey: 'smartWalletAddress',
        header: 'Action',
        enableSorting: false,
        cell: ({ row }: { row: CoreRow<FriendRequest> }) => {
          return (
            <div className="flex justify-end gap-2">
              <Button
                size={ButtonSizes.md}
                variant={ButtonVariants.pokerTable}
                className="!h-9 w-20 px-3 !text-sm"
                onClick={() => handleDecline(row.original.id)}
              >
                Decline
              </Button>
              <Button
                variant={ButtonVariants.primary}
                className="!h-9 w-20 px-3 !text-sm"
                onClick={() => handleAccept(row.original.id)}
              >
                Accept
              </Button>
            </div>
          );
        },
      },
    ],
    [handleAccept, handleDecline],
  );

  return (
    <GenericTable
      data={data}
      columns={columns}
      sorting={sorting}
      onSortingChange={setSorting}
      hover={false}
      gridColClass="grid-cols-[1fr_auto]"
      gridColBorderClass={
        '[&:nth-child(1)]:border-l [&:nth-child(1)]:border-b [&:nth-child(1)]:border-[rgba(255,255,255,0.15)] [&:nth-child(2)]:border-b [&:nth-child(2)]:border-[rgba(255,255,255,0.15)]'
      }
    />
  );
};

export default FriendRequestTable;
